exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".style_container__1_0si{display:flex;justify-content:center;align-items:center;height:1.25rem;color:#fff;font-size:.69rem;text-shadow:0 -.0625rem 0 rgba(0,0,0,.2);padding:0 .25rem;white-space:nowrap;border-radius:.25em;background:#9e9e9e}.style_expected__voO9P,.style_progress__jXOt-{visibility:visible}", ""]);

// exports
exports.locals = {
	"container": "style_container__1_0si",
	"progress": "style_progress__jXOt-",
	"expected": "style_expected__voO9P"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!./node_modules/less-loader/dist/cjs.js!./app/areas/projects/components/ProjectDashboard/TenantDeploymentCount/style.less
// module id = 1467
// module chunks = 8